import { render } from "./CandidateCard.vue?vue&type=template&id=dfaf8bae&scoped=true"
import script from "./CandidateCard.vue?vue&type=script&lang=js"
export * from "./CandidateCard.vue?vue&type=script&lang=js"

import "./CandidateCard.vue?vue&type=style&index=0&id=dfaf8bae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfaf8bae"]])

export default __exports__